
export const ERROR_OK = 1000 // 成功
export const ERROR_PARAMERR = 1001 // 参数错误
export const ERROR_NOTEXIST = 1002 // 资源不存在
export const ERROR_PASSWORD = 1003 // 密码错误
export const ERROR_USERNOTEXIST = 1004 // 用户不存在
export const ERROR_TOKENEXPIRE = 1005 // token过期
export const ERROR_NOTSUPPORTMAILBOX = 1006 // 不支持的邮箱类型
export const ERROR_SENDMAILFAIL = 1007 // 邮件发送失败
export const ERROR_PERMISSIONDIE = 1008 // 权限不足

export const ERROR_VERIFYCODE		= 1009 		// 验证码错误
export const ERROR_FILEEXTERR		= 1010 		// 文件类型错误
export const ERROR_CREATEFILEFAIL		= 1011 		// 创建文件失败
export const ERROR_FETCHINGDEVICEINFO	= 1012 		// 获取device info中
export const ERROR_FETCHDEVICEINFOFAIL	= 1013 		// 获取device info fail
export const ERROR_UNKNOWN = 2000		// 未知错误

export const TEST_ERROR_SUCCESS = 100 // 未知错误
export const TEST_ERROR_UNKNOWN = 101 // 测试成功
export const TEST_ERROR_NODEVICE = 102 // 没有测试设备
export const TEST_ERROR_DEVINFO = 103 // 设备信息错误

export const FINISH = 0 // 测试完成
export const TESTING = 1 // 测试中



//////////////////
// WEBPACK FOOTER
// ./src/api/errorType.js
// module id = null
// module chunks = 